function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Uploader from "../../utils/uploader";
import { VueEditor, Quill } from "vue2-editor";
import TurndownService from "turndown";
import { gfm } from "turndown-plugin-gfm";
export default {
  components: {
    VueEditor: VueEditor
  },
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      customToolbar: [["bold", "italic", "strike"], [{
        header: 1
      }, {
        header: 2
      }], [{
        list: "ordered"
      }, {
        list: "bullet"
      }], ["image", "link"]],
      htmlValue: "",
      cleanValue: null,
      producedValue: "",
      images: {},
      imageKeys: [],
      progress: {
        value: -1
      },
      imageUploader: {},
      produce: null,
      mode: null,
      turndownService: new TurndownService({
        headingStyle: "atx"
      })
    };
  },
  computed: {
    showProgress: function showProgress() {
      return this.progress.value >= 0;
    },
    rawMode: function rawMode() {
      return this.mode == 1;
    }
  },
  watch: {
    cleanValue: function cleanValue(val, oldVal) {
      if (oldVal == null) {
        // Don't update `producedValue` if this is first-time initialization to preserve the original value.
        return;
      }

      switch (this.produce) {
        case "html":
          this.producedValue = val;
          break;

        case "markdown":
          this.producedValue = this.turndownService.turndown(val);
          break;

        default:
          console.log("Unsupported format: ".concat(this.produce));
      }
    },
    producedValue: function producedValue(val) {
      switch (this.produce) {
        case "html":
          this.htmlValue = val;
          break;

        case "markdown":
          this.htmlValue = this.toHtmlValue(val);
          break;

        default:
          console.log("Unsupported format: ".concat(this.produce));
      }
    }
  },
  mounted: function mounted() {
    this.registerScrollEvent();
  },
  methods: {
    $ready: function $ready() {
      this.produce = this.spec.produce || "markdown";
      this.turndownService.use(gfm);
      this.turndownService.addRule("strikethrough", {
        filter: ["del", "s", "strike"],
        replacement: function replacement(content) {
          return "~~" + content + "~~";
        }
      });
      this.turndownService.addRule("codeblock", {
        filter: ["pre"],
        replacement: function replacement(content) {
          return "```\n" + content + "```";
        }
      });
      this.imageUploader = this.spec.imageUploader; // Convert initial markdown value to html for displaying.

      this.producedValue = this.spec.value || "";
      this.htmlValue = this.toHtmlValue(this.producedValue);
    },
    toHtmlValue: function toHtmlValue(producedValue) {
      var vm = this;
      var value = producedValue.replace(/\{\{image([0-9]+)\}\}/g, function (_, index) {
        var image = vm.spec.images[index - 1];

        if (image && vm.$type.isString(image.value) && vm.$type.isString(image.fileUrl)) {
          var url = image.fileUrl;
          var key = url.hashCode().toString();
          vm.images[key] = image.value;
          return url;
        }

        return "{{IMAGE_NOT_FOUND}}";
      });
      return this.produce == "markdown" ? Utils.format.markdown(value) : value;
    },
    uploadImage: function uploadImage(file, editor, cursorLocation) {
      var vm = this;
      var uploaderSpec = this.imageUploader; // const input = this.$refs.directUploadFile

      var upload = new Uploader(file, uploaderSpec.directUploadUrl, this.progress);

      if (upload.validateFile(uploaderSpec)) {
        // TODO
        // EventController.$emit(DISABLE_SUBMIT_BUTTON, true);
        upload.start(function (error, blob) {
          if (error) {// Handle the error
          } else {
            vm.insertImage(file, editor, cursorLocation, blob);
          } // TODO
          // EventController.$emit(DISABLE_SUBMIT_BUTTON, false);

        });
      }
    },
    onEditorChange: function onEditorChange() {
      this.separateOutImages();
      this.onCodeChange();
    },
    onCodeChange: function onCodeChange() {
      var _this = this;

      Utils.type.ifObject(this.spec.onChange, function (onChange) {
        _this.$nextTick(function () {
          var params = _defineProperty({}, _this.spec.paramNameForFormData || "formData", _defineProperty({}, _this.fieldName, _this.fieldModel));

          var data = Object.assign({}, onChange, params);
          GLib.action.execute(data, _this);
        });
      });
    },
    separateOutImages: function separateOutImages() {
      var vm = this;
      var index = 0;
      vm.imageKeys.clear(); // TODO: Fix to avoid replacing <video src="">

      this.cleanValue = this.htmlValue.replace(/src="([^"]+)"/g, function (_, imageValue) {
        // It seems that quill encodes '&' in the URL to '&amp;' which would screw up key matching.
        var decodedValue = imageValue.replace(/&amp;/g, "&");
        var key = decodedValue.hashCode().toString();
        vm.imageKeys.push(key);
        return "src=\"{{image".concat(++index, "}}\"");
      });
    },
    insertImage: function insertImage(file, Editor, cursorLocation, blob) {
      var vm = this;
      var reader = new FileReader();

      reader.onload = function (e) {
        // vm.fileUrl = e.target.result;
        if (file.type.indexOf("image") !== -1) {
          var image = new Image();
          image.src = e.target.result;

          image.onload = function () {
            Editor.insertEmbed(cursorLocation, "image", image.src);
          };

          var key = image.src.hashCode().toString();
          vm.images[key] = blob.signed_id;
        }
      };

      reader.readAsDataURL(file);
      vm.progress.value = -1;
    },
    updateToolbar: function updateToolbar(wrapper, toolbar, container) {
      if (wrapper.scrollTop >= container.offsetTop) {
        toolbar.classList.add("sticky");
        toolbar.style.top = "".concat(wrapper.offsetTop, "px");
        toolbar.style.left = "".concat(wrapper.offsetLeft, "px");
        toolbar.style.width = "".concat(wrapper.offsetWidth, "px");
      } else {
        toolbar.classList.remove("sticky");
        toolbar.style.top = "auto";
        toolbar.style.left = "auto";
        toolbar.style.width = "auto";
      }
    },
    registerScrollEvent: function registerScrollEvent() {
      var _this2 = this;

      var wrapper = document.querySelector(".v-dialog") || window;
      var toolbar = this.$el.querySelector(".ql-toolbar");
      var container = this.$el.querySelector(".ql-container");

      if (wrapper) {
        wrapper.addEventListener("scroll", function () {
          return _this2.updateToolbar(wrapper, toolbar, container);
        });
        window.addEventListener("resize", function () {
          return _this2.updateToolbar(wrapper, toolbar, container);
        });
      }
    }
  }
};